<template>
    <div class="display-media-modal">
        <b-modal :size="size" v-model="showModal" v-bind="modalProps" lazy>
            <display-media
                :media="media"
                :config="{ style: 'min-height: 300px; width: 100%' }"
                :description="description"
                style="padding-bottom: 30px;"
                v-if="media"
            ></display-media>
        </b-modal>
        <portal to="mediaModal">
            <template slot-scope="payload">
                <button :class="_get(payload, 'btnClass', 'btn btn-plain')" @click.prevent="openModal(payload)">
                    {{ _get(payload, 'btnTxt', 'View Media') }}
                </button>
            </template>
        </portal>
    </div>
</template>

<script>
export default {
    props: {
        modalProps: {
            default() {
                return {
                    centered: true,
                    'hide-footer': true,
                    class: 'modal-gg',
                };
            },
        },
    },
    data() {
        return {
            size: 'md',
            btnTxt: null,
            media: null,
            btnClass: null,
            showModal: false,
        };
    },
    created() {
        Bus.$on('openMediaModal', this.openModal);
    },
    methods: {
        openModal(payload) {
            this.description = _.get(payload, 'description', false);
            this.size = _.get(payload, 'size', 'md');
            this.media = payload.media;
            this.showModal = true;
        },
    },
    beforeDestroy() {
        Bus.$off('openMediaModal', this.openModal);
    },
};
</script>

<style lang="scss">
.display-media-modal {
    .display-media {
        padding-bottom: 1.5rem;
    }
}
</style>
